import React from "react";
import "./AstroVastu.css";
import vastuBanner from "../assets/zodiac/Aquarius.jpg";
import BlogSlider from "../components/BlogSlider";
import ServiceProduts from "../components/ServiceProduts";
import ContactForm from "../components/ContactForm"; 

const HealthAstrology = () => {
  return (
    <div className="services-page">
      {/* Left Side - 67% Text Content */}
      <div className="services-content">
       


                <h2>Health Astrology: Your Cosmic Wellness Guide</h2>
                
                <div class="highlight-box">
                    <p>Health astrology examines planetary positions at your birth to reveal physical constitution, potential health vulnerabilities, and optimal wellness strategies. Your birth chart serves as a celestial health blueprint showing innate vitality and areas requiring special care.</p>
                </div>

                <h2>How Astrology Influences Health</h2>
                
                <p>Vedic health astrology analyzes three primary components in your birth chart to understand your wellbeing patterns:</p>
                
                <div class="planet-influence">
                    <div class="planet-card">
                        <h3>The 6th House (Health House)</h3>
                        <p>This crucial house reveals your natural immunity, susceptibility to diseases, and ability to overcome health challenges. Planetary placements here indicate your recovery capacity.</p>
                    </div>
                    <div class="planet-card">
                        <h3>The 1st House (Body House)</h3>
                        <p>Representing physical constitution, this house shows your overall vitality, energy levels, and inherent strengths/weaknesses in different body systems.</p>
                    </div>
                    <div class="planet-card">
                        <h3>The 8th House (Longevity)</h3>
                        <p>This mysterious house governs chronic conditions, healing abilities, and transformative health experiences throughout your life journey.</p>
                    </div>
                </div>

                <h2>Planetary Influences on Health</h2>
                
                <table class="health-table">
                    <tr>
                        <th>Planet</th>
                        <th>Health Influence</th>
                        <th>Vulnerable Areas</th>
                        <th>Remedies</th>
                    </tr>
                    <tr>
                        <td>Sun</td>
                        <td>Vitality, heart, eyes</td>
                        <td>Circulation, vision, bones</td>
                        <td>Surya Namaskar, ruby gemstone</td>
                    </tr>
                    <tr>
                        <td>Moon</td>
                        <td>Fluids, emotions, digestion</td>
                        <td>Stomach, lymph, mental health</td>
                        <td>Meditation, pearl, milk donation</td>
                    </tr>
                    <tr>
                        <td>Mars</td>
                        <td>Energy, muscles, blood</td>
                        <td>Inflammation, injuries, fever</td>
                        <td>Physical exercise, coral</td>
                    </tr>
                    <tr>
                        <td>Mercury</td>
                        <td>Nervous system, lungs</td>
                        <td>Anxiety, breathing, skin</td>
                        <td>Pranayama, emerald</td>
                    </tr>
                    <tr>
                        <td>Jupiter</td>
                        <td>Liver, metabolism</td>
                        <td>Obesity, diabetes, cholesterol</td>
                        <td>Turmeric, yellow sapphire</td>
                    </tr>
                    <tr>
                        <td>Venus</td>
                        <td>Reproductive, urinary</td>
                        <td>Hormones, kidneys, fertility</td>
                        <td>Diamond, white foods</td>
                    </tr>
                    <tr>
                        <td>Saturn</td>
                        <td>Bones, joints, teeth</td>
                        <td>Arthritis, chronic pain</td>
                        <td>Yoga, blue sapphire</td>
                    </tr>
                </table>

                <h2>Zodiac Signs and Health Tendencies</h2>
                
                <div class="zodiac-health">
                    <h3>Aries (March 21 - April 19)</h3>
                    <p>Strong vitality but prone to headaches, injuries, and inflammation. Benefit from vigorous exercise and stress management.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Taurus (April 20 - May 20)</h3>
                    <p>Robust constitution but vulnerable to throat and thyroid issues. Require regular vocal rest and neck care.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Gemini (May 21 - June 20)</h3>
                    <p>Active nervous system benefits from mental stimulation but needs protection from respiratory ailments and anxiety.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Cancer (June 21 - July 22)</h3>
                    <p>Sensitive digestive system requires careful nutrition. Emotional wellbeing directly impacts physical health.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Leo (July 23 - August 22)</h3>
                    <p>Strong heart but vulnerable to circulatory issues and back pain. Benefit from cardio exercise and posture awareness.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Virgo (August 23 - September 22)</h3>
                    <p>Efficient metabolism but prone to digestive disorders and food sensitivities. Require balanced diet and routine.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Libra (September 23 - October 22)</h3>
                    <p>Kidney and skin sensitivities. Benefit from proper hydration and pH-balanced nutrition.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Scorpio (October 23 - November 21)</h3>
                    <p>Strong regenerative abilities but vulnerable to reproductive and elimination system issues. Benefit from detox practices.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Sagittarius (November 22 - December 21)</h3>
                    <p>Active lifestyle protects health but vulnerable to liver issues and muscular strains. Benefit from moderation.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Capricorn (December 22 - January 19)</h3>
                    <p>Strong bones but prone to joint issues and skin conditions. Require calcium-rich diet and mobility exercises.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Aquarius (January 20 - February 18)</h3>
                    <p>Unique circulatory system requires special attention to blood flow and nervous system balance.</p>
                </div>
                
                <div class="zodiac-health">
                    <h3>Pisces (February 19 - March 20)</h3>
                    <p>Sensitive immune system and foot vulnerabilities. Benefit from water therapies and immune support.</p>
                </div>

                <h2>Astrological Remedies for Health</h2>
                
                <div class="planet-influence">
                    <div class="planet-card">
                        <h3>Gemstone Therapy</h3>
                        <p>Wearing appropriate gemstones can balance planetary energies affecting health. Consult an astrologer for personalized recommendations.</p>
                    </div>
                    <div class="planet-card">
                        <h3>Mantra Healing</h3>
                        <p>Specific planetary mantras help strengthen weakened energies. Regular chanting creates vibrational healing.</p>
                    </div>
                    <div class="planet-card">
                        <h3>Yantra Energy</h3>
                        <p>Sacred geometric yantras placed in your environment can harmonize health-affecting planetary influences.</p>
                    </div>
                </div>

                <div class="highlight-box">
                    <p>Remember: While health astrology reveals your constitutional tendencies, your lifestyle choices and preventive care play equally important roles. As ancient wisdom teaches, "Prevention is better than cure" - use astrological insights proactively to maintain optimal wellbeing.</p>
                </div>
        {/* FAQs */}
        <div className="faq-section">
          <h3>Frequently Asked Questions</h3>
          <div className="faq"><h4>What is Astro Vastu?</h4><p>Astro Vastu combines Vastu Shastra with astrology to bring personalized solutions based on your birth chart.</p></div>
          <div className="faq"><h4>Can this service be done remotely?</h4><p>Yes, we offer remote consultations through video calls and shared floor plans.</p></div>
          <div className="faq"><h4>How do I choose a gemstone?</h4><p>We analyze your birth chart and planetary positions to recommend suitable gemstones.</p></div>
          <div className="faq"><h4>What is the benefit of Rudraksha?</h4><p>Rudraksha beads help in spiritual growth and balancing chakras and energy fields.</p></div>
        </div>

        {/* Blog Slider */}
            <div className="recent-blogs">
                    
                     <BlogSlider />
            </div>

      </div>

      {/* Right Side - 33% Banner Image, Contact, Social, Buy */}
      <div className="sidebar">
        <div className="banner-image">
          <img src="/assets/profile/Jyotish_karam_profile.jpeg" alt="Astro Vastu Services Banner" />
        </div>

        <div className="social-follow">
          <h4>Follow Us</h4>
          <div className="social-icons">
            <a href="#"><i className="fab fa-facebook-f" /></a>
            <a href="#"><i className="fab fa-instagram" /></a>
            <a href="#"><i className="fab fa-twitter" /></a>
            <a href="#"><i className="fab fa-linkedin-in" /></a>
            <a href="#"><i className="fab fa-pinterest-p" /></a>
            <a href="#"><i className="fab fa-youtube" /></a>
          </div>
        </div>

        <div className="contact-form">
          <h3>Contact Us</h3>
          <form>
            <input type="text" placeholder="Name" required />
            <input type="email" placeholder="Email" required />
            <input type="tel" placeholder="Phone No" required />
            <select required>
              <option value="">Select Service</option>
              <option value="vastu">Astro Vastu Consultation</option>
              <option value="gemstone">Gemstone Suggestion</option>
              <option value="puja">Puja or Remedy Guidance</option>
            </select>
            <textarea placeholder="Please Write Any Note Here..." required />
            <button type="submit">Submit</button>
          </form>
        </div>

          <ContactForm />
          <ServiceProduts />
        
      </div>
    </div>
  );
};

export default HealthAstrology;
